import { AnnotationRenderer } from './rendering/annotation_renderer';

export const RenderingFactory = {
    create: function (options, eventBus) {
        return new AnnotationRenderer(options, eventBus);
    }
}